import React from "react";
import {InstagramEmbed} from 'react-social-media-embed';
import {v4 as uuidv4} from 'uuid';
import loadable from "@loadable/component";
const instagram = require("./instagram.json");
const Grid = loadable(() => import('@material-ui/core/Grid'));

function Instagram(props) {
    let count = 0;
    const items = instagram.map((embed, index) => {
        let random = Math.floor(Math.random() * 3);
        let results = ((index+(random*2)) % random) === 0;
        if(results === true && count <= 5) {
            count++
        return(
        <Grid item key={uuidv4()} md={4}>
            <InstagramEmbed url={embed} width={328} height={660}/>
        </Grid>
        )
    }
        return true;
    });
    return (
        <Grid container spacing={3} justifyContent="center" style={{marginLeft: "30px", marginTop: "20px", marginBottom: "5px"}}>
            {items}
        </Grid>
    )
}
export default Instagram;